import React from 'react';
import { func, number, object, shape, bool, string } from 'prop-types';
import { Box, Button, Typography } from '@mui/material';

import { Chip, CodeBlock, Spinner } from '../../../../../../../../components';

const staticText = {
  dataResponse: 'Data callback URI response',
  errorResponse: 'Error callback URI response',
  buttons: {
    resendData: 'Re-send data test request',
    resendError: 'Re-send error test request',
    done: 'Done',
  },
};

const translateStatusCodeToMessage = (code) => {
  if (code < 300) return 'ok';
  if (code < 400) return 'redirect';
  return 'error';
};

const getCodeFromResponse = (response) => {
  return Object.keys(response).length ? JSON.stringify(response, null, 2) : '';
};

const Response = ({
  response,
  testWebhook,
  toggleModal,
  isFetching,
  type,
}) => {
  const {
    body, statusCode,
  } = response;

  const statusCodeType = translateStatusCodeToMessage(statusCode);

  const buttonText = type === 'error' ? staticText.buttons.resendError : staticText.buttons.resendData;

  return (
    <Box display="flex" flexDirection="column" gap={2} marginTop={3}>
      <div>
        <Typography variant="body2" marginRight={1} component="span" sx={theme => ({ fontFamily: theme.typography.bold.fontFamily })}>{
          type === 'error' ? staticText.errorResponse : staticText.dataResponse
        }
        </Typography>
        <Chip
          label={`${statusCode ? `${statusCode} ` : ''}${statusCodeType}`.toUpperCase()}
          // eslint-disable-next-line no-nested-ternary
          type={statusCodeType === 'ok' ? 'success' : statusCodeType === 'redirect' ? 'info' : 'error'}
        />
      </div>
      {body && <CodeBlock code={getCodeFromResponse(body)} />}
      <Box display="flex" justifyContent="flex-end" gap={1} marginTop={2}>
        <Button
          variant="outlined"
          onClick={() => testWebhook(type)}
          startIcon={isFetching && <Spinner size="button" />}
        >
          {buttonText}
        </Button>
        <Button
          variant="outlined"
          color="secondary"
          onClick={() => toggleModal(false)}
        >
          {staticText.buttons.done}
        </Button>
      </Box>
    </Box>
  );
};

export default Response;

Response.propTypes = {
  isFetching: bool.isRequired,
  response: shape({
    body: object,
    statusCode: number,
  }).isRequired,
  testWebhook: func.isRequired,
  toggleModal: func.isRequired,
  type: string,
};

Response.defaultProps = {
  type: 'data',
};
